import React, { useRef } from "react";

const useInputPhoneMask = (
  fn: (e: React.ChangeEvent<HTMLInputElement>, z: boolean) => void,
  prefix: string,
) => {
  const number = useRef<string>("");

  const isError = (value: string, prefix: string): boolean => {
    if (!prefix || !value) return false;

    const firstChar = value[0];
    return firstChar !== prefix || value.length === 1;
  };

  const onChangeEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.currentTarget;
    value = value.replace(/[^0-9+]/g, "");

    if (value.split("+").length > 2) {
      value = value.slice(0, value.lastIndexOf("+"));
    }

    e.currentTarget.value = value;
    fn.call(null, e, isError(number.current, prefix));
  };

  return {
    onChangeEvent,
    isError: isError(number.current, prefix),
  };
};

export default useInputPhoneMask;
